import * as CubiqTS from "shared/cubiq-model-multi-asset";

// NOTE: ORDER OF THIS ARRAY MUST MATCH CubiqTS.Operator
export const BfxFindFilterConditionLabels = [
  { label: "=", value: CubiqTS.Operator.In },
  { label: "<>", value: CubiqTS.Operator.NotIn },
  { label: "=", value: CubiqTS.Operator.Equal },
  { label: "<>", value: CubiqTS.Operator.NotEqual },
  { label: "<", value: CubiqTS.Operator.Less },
  { label: "<=", value: CubiqTS.Operator.LessOrEqual },
  { label: ">", value: CubiqTS.Operator.Greater },
  { label: ">=", value: CubiqTS.Operator.GreaterOrEqual },
  { label: "between", value: CubiqTS.Operator.Between },
  { label: "not between", value: CubiqTS.Operator.NotBetween },
  { label: "is null", value: CubiqTS.Operator.IsNull },
  { label: "is not null", value: CubiqTS.Operator.IsNotNull },
  { label: "contains", value: CubiqTS.Operator.Contains },
  { label: "does not contain", value: CubiqTS.Operator.DoesNotContain },
];
